<template>
  <b-card 
    class="shadow chat-container"
  >
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5>Conversa com {{ usuario?.nome_usuario || "Usuário" }}</h5>
      <div>
        <b-button variant="success" class="mr-2" @click="exportarConversa">
          <i class="mdi mdi-file-excel"></i> Exportar CSV
        </b-button>

        <b-button variant="secondary" @click="$router.back()">
          <i class="mdi mdi-arrow-left"></i> Voltar
        </b-button>
      </div>
    </div>

    <!-- Lista de mensagens -->
    <div v-if="mensagens.length" class="chat-wrapper">
      <div
        v-for="msg in mensagens"
        :key="msg.id"
        class="chat-row"
        :class="{
          'row-bot': msg.tipo_usuario.toUpperCase() === 'BOT',
          'row-user': msg.tipo_usuario.toUpperCase() === 'USUÁRIO' || msg.tipo_usuario.toUpperCase() === 'ATENDENTE'
        }"
      >
        <div class="bubble-wrapper">
          <div 
            class="bubble"
            :class="{
              'bot': msg.tipo_usuario.toUpperCase() === 'BOT',
              'user': msg.tipo_usuario.toUpperCase() === 'USUÁRIO',
              'atendente': msg.tipo_usuario.toUpperCase() === 'ATENDENTE'
            }"
          >
            <div class="sender">
              <i :class="msg.tipo_usuario.toUpperCase() === 'BOT' ? 'mdi mdi-robot' : 'mdi mdi-account'"></i>
              {{ msg.tipo_usuario.toUpperCase() === "BOT" ? "BOT" : msg.tipo_usuario.toUpperCase() === "ATENDENTE" ? "ATENDENTE" : "USUÁRIO" }}
            </div>

            <div class="message-text">
              {{ msg.preview || msg.texto_mensagem }}
            </div>

            <div class="timestamp">
              {{ formatarData(msg.dt_envio) }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Caso não haja nada -->
    <div v-else class="text-center my-4">
      <img src="/img/icons/robot.svg" style="max-height: 120px" />
      <p>Nenhuma mensagem encontrada.</p>
    </div>
  </b-card>
</template>

<script>
import axios from "axios";

export default {
  name: "VisualizarConversa",
  data() {
    return {
      mensagens: [],
      usuario: null,
    };
  },

  methods: {
    async carregarConversa() {
      try {
        const conversation_id = this.$route.params.conversation_id;

        const conversation_id_suas = this.$route.params.conversation_id_suas;

        const res = await axios.get(
          `/api/dashboard/botpress/conversas/${conversation_id}/${conversation_id_suas}`
        );

        this.mensagens = res.data.mensagens || [];
        this.usuario = res.data.usuario || null;
      } catch (e) {
        console.error("Erro ao carregar conversa:", e);
      }
    },

    formatarData(data) {
      return new Date(data.replace(" ", "T")).toLocaleString("pt-BR");
    },

    async exportarConversa() {
      const id = this.$route.params.conversation_id;

      const id2 = this.$route.params.conversation_id_suas;

      try {
        const response = await axios.get(
          `/api/dashboard/botpress/conversas/${id}/${id2}/exportar`
        );

        // A rota retorna uma URL do CSV — então abrimos direto
        window.open(response.data, "_blank");
      } catch (e) {
        console.error("Erro ao exportar conversa:", e);
        this.$bvToast.toast("Erro ao exportar a conversa.", {
          title: "Erro",
          variant: "danger",
          solid: true
        });
      }
    }
  },

  mounted() {
    this.carregarConversa();
  },
};
</script>

<style scoped>
.chat-container {
  max-width: 650px;        /* CENTRALIZA E DEIXA MAIS COMPACTO */
  margin: 0 auto;          /* Centralizar horizontalmente */
  padding: 20px !important;
}

.chat-wrapper {
  margin-top: 10px;
}

.chat-row {
  display: flex;
  margin-bottom: 6px;       /* DISTÂNCIA ENTRE BALÕES REDUZIDA */
}

.row-user {
  justify-content: flex-end;
}

.row-bot {
  justify-content: flex-start;
}

.bubble-wrapper {
  max-width: 70%;
}

.bubble {
  padding: 10px 14px;
  border-radius: 12px;
  font-size: 0.85rem;
  line-height: 1.3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.bubble.user {
  background: #007bff;
  color: #fff;
  text-align: right;
}

.bubble.atendente {
  background: #FFD580; /* Laranja claro */
  color: #333;
  text-align: right;
}

.bubble.bot {
  background: #f5f5f5;
  color: #333;
  text-align: left;
}

.sender {
  font-size: 0.75rem;
  font-weight: bold;
  opacity: 0.85;
  margin-bottom: 3px;
}

.sender i {
  font-size: 1rem;
  margin-right: 3px;
}

.timestamp {
  font-size: 0.70rem;
  opacity: 0.7;
  margin-top: 4px;
}

.message-text {
  margin-top: 2px;
}
</style>
